import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { cargasPreviasAction, obtenerIngresoPagosExcel } from '../../store/actions/carga-masiva-action';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DetalleCarga from "./detalle-carga";
import { SiMicrosoftexcel } from 'react-icons/si'
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Modal } from 'react-bootstrap'
import { Auth } from 'recupero-comunes';

const CargasPrevias = () => {
    const [todosPagos, setTodosPagos]=useState(true)
    const [misColumnas, setColumnas]=useState([])
    const [lista, setLista]=useState([])
    const [show, setShow] = useState(false)
    const [idSelect, setIdSelect] = useState("")
    const { rutOrganizacion } = Auth.currentUser();
    const query = btoa(JSON.stringify({ "idOrganizacion": 8600399880, "tipoCarga":"108003" }));
   
    // El hook useSelector (redux) permite acceder al state en nuestro store.
    const dataCargaMasiva = useSelector(state => state.cargaMasivaReducer);
    const {cargas_previas}=dataCargaMasiva
    // El hook useDispatch (redux) permite invocar una action.
    const dispatch = useDispatch();
    
    // El hook useState permite almacenar state. Devuelve un valor con el estado y una función
    const [ verDetalle, setVerDetalle ] = React.useState({ show: false, data: {} });
  
    const handleReload = () => {

        // Ejecutar acción para obtener cargas previsa.
        dispatch(cargasPreviasAction(query));
    }
    const handleShow = () => setShow(true)

    const handleNoPagos = () => {  
        let query = Buffer.from(
            JSON.stringify({
            idOrgCaso: rutOrganizacion,
              idCarga: idSelect,
              checkTodos:false
            })
          ).toString('base64')
        dispatch(obtenerIngresoPagosExcel(query))
        setShow(false)
       
      }
    const handleTodosPagos=()=>{
       
        let query = Buffer.from(
            JSON.stringify({
            idOrgCaso: rutOrganizacion,
              idCarga: idSelect,
              checkTodos:true
            })
          ).toString('base64')
        dispatch(obtenerIngresoPagosExcel(query))
        setShow(false)
    }
    const handleClose=()=>{
        setShow(false)
    }
    useEffect(()=>{
        if(dataCargaMasiva.ingresoPagos){
            var link = document.createElement("a");
            link.download = dataCargaMasiva.ingresoPagos.ingresoPagos.file["filename"];
            link.href = "data:" + dataCargaMasiva.ingresoPagos.ingresoPagos.file["mimetype"] + ";base64," + dataCargaMasiva.ingresoPagos.ingresoPagos.file["xlsxfile"];
            link.click();
           
        }
    },[dataCargaMasiva.ingresoPagos])
    useEffect(() => {

        // Ejecutar acción para obtener cargas previsa.
        dispatch(cargasPreviasAction(query));

    }, [dispatch]);


    const handleTodos=(e)=>{
        setTodosPagos(e.target.checked)
        dispatch(cargasPreviasAction(query))
      
        
    }
    
    const handleIngresoPagos=(row)=>{
        setIdSelect(row.id)
       handleShow()
        
       
         
    }
    // Definición de propiedades de cada columna de la tabla
    const columns=() => [
        { 
            dataField: 'id', text: 'ID Carga', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '7%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'fechaCargaFormato', text: 'Fecha Carga', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '9%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'nombreArchivo', text: 'Archivo Caja',headerAlign: 'center', headerStyle: { textAlign: 'center', verticalAlign: 'middle', align: 'center' }, headerStyle: (colum, colIndex) => {
                return { width: '25%', textAlign: 'center' ,verticalAlign: 'middle', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'regCargados', text: 'Cnt Pagos', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '8%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'regRechazados', text: 'Cnt Rechazado', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'regConciliados', text: 'Cnt Conciliado', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),
            headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'estadoCarga', text: 'Estado', sort: true, headerAlign: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '12%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'usuarioCarga', text: 'Usuario', sort: true, headerAlign: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),headerStyle: (colum, colIndex) => {
                return { width: '10%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }
        }, 
        {
            dataField: 'opciones', text: '', isDummyField: true, headerStyle: (colum, colIndex) => {
                return { width: '40%', textAlign: 'center' ,verticalAlign: 'center', backgroundColor: '#728bb0', color:"white"};
              }, 
            style: { textAlign: 'center', verticalAlign: 'middle' },
            formatter: (cell, row) => (
                <div>
                    {/* Button Show Dialog */}
                    {
                        row.erroresCarga && row.erroresCarga.length!==undefined && row.erroresCarga.length>0 &&
                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Resultado de Errores </Tooltip>}>
                    <Button type="button" variant="outline-secondary me-md-2" size="sm" onClick={ () => {
                      
                        setVerDetalle({ show: true, data: row })} }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </Button>
                </OverlayTrigger>
                    }
                    {/* Button Show File */}
                    
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Ver Ingreso de Pagos </Tooltip>}>
                    <Button type="button" variant="outline-success" size="sm"  onClick={()=>{
                        
                        handleIngresoPagos(row)}}>
                        
                        <SiMicrosoftexcel  />
                    </Button>
                    </OverlayTrigger>
                </div>
            ),headerStyle: { backgroundColor: '#728bb0', color:"white" }
        }
    ];
   
    return (
        <div>
         <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>ELija una de las opciones!!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           Desea incluir todos los pagos?
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={handleTodosPagos}>
            Sí
          </Button>
          <Button variant='secondary' onClick={handleNoPagos}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
            <ToolkitProvider search bootstrap4 keyField="id" 
                data={ dataCargaMasiva.cargas_previas ? dataCargaMasiva.cargas_previas : [] } 
              
            
                columns={ columns() } defaultSorted={ [{ dataField: 'id', order: 'asc' }] }>
                { 
                props =>
                    <div>
                        <div className=" rounded mt-4" style={{backgroundColor:"#4F517A", color:"#ffff"}}>
                            <h5 className="text-center p-2">Cargas Previas</h5>
                        </div>
                        <div className="d-md-flex justify-content-md-end rounded mt-4">
                        <Button type="button" variant="outline-info" size="sm" onClick={ handleReload}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                     </Button>
                     </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                           
                                <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                           
                        </div>
                        <BootstrapTable { ...props.baseProps } bordered={ false }  pagination={ paginationFactory() } />
                    </div>
                }
            </ToolkitProvider>
            <DetalleCarga show={verDetalle.show} data={verDetalle.data} onHide={() => setVerDetalle({ show: false, data: {} })} />
        </div>
    );
}

export default CargasPrevias;